import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'



import BoxButton from '../Layout/BoxButton'
import BoxSection from '../Layout/BoxSection'
import ModalAddFile from '../Shared/ModalAddFile'
import ModalAddAsistencia from './ModalAddAsistencia'


import { 
    displayModalAddAsistencia, 
    addFile,
} from '../../actions/tiquetesaereo'


import { 
    displayModalAddFile, 
    downloadFile
} from '../../actions/common'


class Asistencia extends Component {

	render() {
        
        const { id, tiquetesaereo } = this.props
        if (!id) return null

        
        return ( 
        <Fragment>

            <BoxSection title="Registro de asistencias compradas">

                <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-tiquetes">                                    
                    <thead>
                        <tr>
                            <th style={{ width: '30px' }}></th>
                            <th style={{ width: '10%', textAlign: 'center' }}>No. Pasaj.</th>
                            <th style={{ width: '10%' }}>No. Voucher</th>
                            <th style={{ width: '12%' }}>Valor asistencia</th>
                            <th style={{ width: '10%' }}>Fecha compra</th>
                            <th style={{ width: '16%' }}>Proveedor</th>
                            <th style={{ width: '10%' }}>Destino</th>
                            <th style={{ width: '10%' }}>Fecha salida</th>
                            <th style={{ width: '10%' }}>Fecha regreso</th>
                            <th style={{ width: '12%' }}>
                            {
                                tiquetesaereo.get('estado') == 4 ? 'Adjuntar voucher' :'Descargar voucher'
                            }
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        (tiquetesaereo.getIn(['viaje', 'pasajeros']).count() > 0) && tiquetesaereo.getIn(['viaje', 'pasajeros']).map((x, n) => { 

                            const fileid = x.getIn(['asistencia', 'adjunto', 'id']) ? x.getIn(['asistencia', 'adjunto', 'id']) : null
                            const filename = x.getIn(['asistencia','adjunto', 'nombre']) ? x.getIn(['asistencia', 'adjunto', 'nombre']) : null

                            return (
                            <tr key={ `tr[${n}]`}>
                                <td style={{ textAlign: 'center' }}><BoxButton size={ 12 } name="pencil" onClick={ () => this.props.displayModalAddAsistencia(true, 'Agregar asistencia al viajero', n) } disabled={tiquetesaereo.get('estado') < 4 || tiquetesaereo.get('estado') > 6}/></td>
                                <td className="text-right">{n+1}</td>
                                <td>{x.getIn(['asistencia', 'numero_voucher'])}</td>
                                <td>{x.getIn(['asistencia', 'valor'])}</td>
                                <td>{ x.getIn(['asistencia', 'fecha_compra']) ? moment(x.getIn(['asistencia', 'fecha_compra'])).format('DD/MM/YYYY') : '' }</td>
                                <td>{x.getIn(['asistencia', 'proveedor'])}</td>
                                <td>{x.getIn(['asistencia', 'pais_destino'])}</td>
                                <td>{ moment(x.getIn(['asistencia', 'fecha_salida'])).format('DD/MM/YYYY') }</td>
                                <td>{ moment(x.getIn(['asistencia', 'fecha_regreso'])).format('DD/MM/YYYY') }</td>
                                {
                                    x.getIn(['asistencia', 'adjunto', 'id']) ? (
                                        <td style={{ cursor: 'pointer' }} onClick={ () => this.props.downloadFile(fileid, filename) }>
                                         	<i className="fa fa-download"></i>
		                                    <span style={{ marginLeft: '3px' }}>{`${x.getIn(['asistencia', 'adjunto', 'nombre'])}`}</span>    
                                        </td>
                                    ) : (
                                        <td>
                                            { x.getIn(['asistencia', 'adjunto', 'file']) ?  x.getIn(['asistencia', 'adjunto', 'file']).name : 'Archivo sin adjuntar' }
                                        </td>
                                    )
                                }
                            </tr>
                            )
                        }) 
                    }
                    </tbody>
                </table>
            
            </BoxSection>

            <ModalAddAsistencia displayModalAddFile={ this.props.displayModalAddFile }/>

            <ModalAddFile
                action={ () => this.props.addFile('modalAddAsistencia.data.asistencia.adjunto') }
            />


        </Fragment> 
        )
	}
}

function mapStateToProps(state) {
    return {
        id: state.tiquetesaereo.get('id'),
        tiquetesaereo: state.tiquetesaereo.get('solicitud')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        displayModalAddAsistencia: (show, title, index) => dispatch(displayModalAddAsistencia(show, title, index)), 
        displayModalAddFile: (show, title, mode, index) => dispatch(displayModalAddFile(show, title, mode, index)),
        addFile: (path) => dispatch(addFile(path)), 
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Asistencia)


// WEBPACK FOOTER //
// ./src/components/TiquetesAereos/Asistencia.jsx